
<template>
  <div class="vx-row w-full my-4">
    <div class="vx-col mt-8 w-full xs:w-full">
      <span>تصویر کارت ملی: </span>

      <picture-manager
        @click="showNationalCard"
        @show="showNationalCard"
        @remove="removeNationalCard"
        @change="uploadNationalCard"
        defaultText="تصویر کارت ملی"
        :attachments="attachments.NationalCard"
      />
    </div>
    <div class="vx-col mt-8 w-full xs:w-full">
      <span>تصویر شناسنامه:</span>
      <picture-manager
        @click="showPersonalCertificate"
        @show="showPersonalCertificate"
        @remove="removePersonalCertificate"
        @change="uploadPersonalCertificate"
        defaultText="تصویر شناسنامه"
        :attachments="attachments.PersonalCertificate"
      />
    </div>
    <div class="vx-col mt-8 w-full xs:w-full">
      <span>تصویر جواز کسب:</span>
      <picture-manager
        @click="showBusinessCertificate"
        @show="showBusinessCertificate"
        @remove="removeBusinessCertificate"
        @change="uploadBusinessCertificate"
        defaultText="تصویر جواز کسب"
        :attachments="attachments.BusinessCertificate"
      />
    </div>

    <vue-easy-lightbox
      escDisabled
      moveDisabled
      :visible="visible"
      :imgs="lightboxImages"
      :index="lightboxIndex"
      @hide="visible = false"
    ></vue-easy-lightbox>
  </div>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
</style>
<script>
import Lightbox from "vue-easy-lightbox";
import { AttachmentType } from "@/enums.js";
import PictureManager from "@/components/PictureManager.vue";
export default {
  name: "attachments",
  props: {},
  components: {
    "picture-manager": PictureManager,
    Lightbox,
  },
  props: {
    id: 0,
  },
  data() {
    return {
      visible: false,
      lightboxImages: [],
      lightboxIndex: 0,
      AttachmentType,
      attachments: {
        BusinessCertificate: [],
        NationalCard: [],
        PersonalCertificate: [],
      },
    };
  },
  watch: {
    id: {
      handler: function () {
        this.load();
      },
    },
  },
  methods: {
    load() {
      if (this.id) {
        this.getAtachment(this.AttachmentType.NationalCard);
        this.getAtachment(this.AttachmentType.PersonalCertificate);
        this.getAtachment(this.AttachmentType.BusinessCertificate);
      }
    },
    async getAtachment(attachmentType) {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          DraftRequestId: this.id,
          AttachmentType: attachmentType.value,
        },
      };
      this.$http
        .get(`api/services/app/Draft/GetAttachments`, payload)
        .then((response) => {
          if (response.data.result[0]) {
            //response.data.result contains array of attachments
            //every attachment has bytes and an object that has its metadata
            this.attachments[attachmentType.name] = response.data.result.map(
              (x) => {
                return {attachment:x.attachment, src: "data:image/img;base64," + x.bytes };
              }
            );
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    showNationalCard(i) {
      this.showFile(this.AttachmentType.NationalCard, i);
    },
    showPersonalCertificate(i) {
      this.showFile(this.AttachmentType.PersonalCertificate, i);
    },
    showBusinessCertificate(i) {
      this.showFile(this.AttachmentType.BusinessCertificate, i);
    },
    showFile(attachmentType, i) {
      this.visible = true;
      this.lightboxImages = this.attachments[attachmentType.name];
      this.lightboxIndex = i;
    },
    removeNationalCard(i) {
      this.removeFile(this.AttachmentType.NationalCard, i); //BusinessCertificate
    },
    removePersonalCertificate(i) {
      this.removeFile(this.AttachmentType.PersonalCertificate, i); //BusinessCertificate
    },
    removeBusinessCertificate(i) {
      this.removeFile(this.AttachmentType.BusinessCertificate, i); //BusinessCertificate
    },
    removeFile(attachmentType, i) {
      let loading = this.$vs.loading();
      let payload = {
        Id: this.attachments[attachmentType.name][i].attachment.id,
      };

      this.$http
        .post("/api/services/app/Draft/RemoveAttachment", payload)
        .then((response) => {
          if (response.data.success) {
            this.getAtachment(attachmentType);
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `تصویر ${
                this.AttachmentType[attachmentType.name].title
              } حذف شد`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    
    uploadNationalCard(e) {
      this.upload(e, this.AttachmentType.NationalCard); //BusinessCertificate
    },
    uploadPersonalCertificate(e) {
      this.upload(e, this.AttachmentType.PersonalCertificate); //BusinessCertificate
    },
    uploadBusinessCertificate(e) {
      this.upload(e, this.AttachmentType.BusinessCertificate); //BusinessCertificate
    },
    upload(e, attachmentType) {
      let loading = this.$vs.loading();

      let formData = new FormData();
      formData.append("File", e.target.files[0]);
      formData.append("AttachmentType", attachmentType.value);
      formData.append("DraftRequestId", this.id);

      this.$http
        .post("/api/services/app/Draft/UploadAttachment", formData)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `تصویر ${
                this.AttachmentType[attachmentType.name].title
              } با موفقیت ذخیره شد`,
            });
            this.getAtachment(attachmentType);
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },

  },
  mounted() {
    this.load();
  },
};
</script>